import { graphql } from 'gatsby';
import { VersatileLink } from '../types/types';

export const NavigationMenuFragment = graphql`
  fragment NavigationMenu on SanityMenuNestedEntryOrMenuSingleEntry {
    __typename
    ... on SanityMenuSingleEntry {
      title {
        ...LocaleStringFragment
      }
      internalLink {
        pageReference {
          ...PageReference
        }
        anchorLink
      }
      externalLink {
        url
      }
    }
    ... on SanityMenuNestedEntry {
      title {
        ...LocaleStringFragment
      }
      entriesType
      entries {
        title {
          ...LocaleStringFragment
        }
        internalLink {
          pageReference {
            ...PageReference
          }
          anchorLink
        }
        externalLink {
          url
        }
      }
    }
  }
`;

export type SingleEntry = {
  title: string;
} & VersatileLink;

export type NestedEntry = {
  title: string;
} & (
  | {
      entriesType: 'areasOfExpertise';
      entries?: never;
    }
  | {
      entriesType: 'pages';
      entries: Array<SingleEntry>;
    }
);

export type NavigationMenu = Array<SingleEntry | NestedEntry>;

export function isNestedEntry(entry: SingleEntry | NestedEntry): entry is NestedEntry {
  return 'entriesType' in entry;
}
